import { useMemo } from 'react';
import { INDICATION_TYPES } from 'taboola-ultimate-ui';
import {
    COMMON_FLAGS,
    FEATURE_FLAGS,
    useCommonConfig,
    useConfigMatch,
} from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormValidatedValue, validationFunctions } from 'modules/taboola-common-frontend-modules/validations';

const validations = [
    {
        validationFn: validationFunctions.isFloatOrEmpty,
        options: { min: 0, max: 99 },
        messageId: 'validations.error.campaign.profitMargin.invalid',
        defaultMessage: 'Profit margin cannot be negative and must be less than 100%',
    },
    {
        validationFn: value => value === null || value === '' || /^[0-9]+(\.[0-9]{1,4})?$/.test(String(value)),
        messageId: 'validations.error.campaign.profitMargin.max.four.digits',
        defaultMessage: 'Profit margin value can have at most 4 digits after the decimal point',
    },
    {
        validationFn: validationFunctions.range,
        options: { lt: 'minPercentageForWarning' },
        messageId: 'validations.warning.campaign.profitMargin.value.too.high',
        defaultMessage: 'Profit margin rate is above recommended value, consider adjusting it to remain competitive',
        severity: INDICATION_TYPES.WARNING,
    },
];
export const useProfitMarginFormFieldValue = () => {
    const isPermitted = useConfigMatch({ [FEATURE_FLAGS.PROFIT_MARGIN_ENABLED]: 'true' });
    const { [COMMON_FLAGS.PROFIT_MARGIN_MIN_VALUE_FOR_WARNING]: minValueForWarningConfig } = useCommonConfig([
        COMMON_FLAGS.PROFIT_MARGIN_MIN_VALUE_FOR_WARNING,
    ]);

    const validationDependencies = useMemo(
        () => ({
            data: {
                minPercentageForWarning: minValueForWarningConfig * 100,
            },
        }),
        [minValueForWarningConfig]
    );
    const props = useFormValidatedValue({
        field: 'finance.profitMargin',
        isPermitted,
        validations,
        validationDependencies,
    });

    return { ...props, isPermitted };
};
